import { useEffect, useState } from 'react';

import { Alert } from '@ds/feedback';
import { Switch } from '@ds/forms';
import { useAviso } from '@/comuns/toast';
import { dados } from '@/data/porta';

/**
 * Exigir MFA para as ações de ESCRITA do painel — trilha T6, migração 0099.
 *
 * Nasce desligado. Ligado, a sessão que não entrou com o segundo fator continua
 * LENDO o painel e deixa de escrever: quem perdeu o celular não fica cego para
 * resolver. Só liga quem já está com o MFA nesta sessão — o banco recusa o resto,
 * e a mensagem dele aparece aqui.
 */
export function ExigenciaDeMfa({ semMfa }: { semMfa: string[] }) {
    const aviso = useAviso();
    const [ligado, setLigado] = useState<boolean | null>(null);
    const [erro, setErro] = useState<string | null>(null);
    const [salvando, setSalvando] = useState(false);

    useEffect(() => {
        let vivo = true;
        dados().mfaObrigatorioParaEscrita()
            .then((v) => { if (vivo) { setLigado(v); setErro(null); } })
            .catch((e: unknown) => { if (vivo) setErro(e instanceof Error ? e.message : 'Não foi possível ler a exigência de MFA.'); });
        return () => { vivo = false; };
    }, []);

    const alternar = async (valor: boolean) => {
        setSalvando(true);
        setErro(null);
        try {
            setLigado(await dados().definirMfaObrigatorioParaEscrita(valor));
            aviso({
                title: valor ? 'MFA exigido para escrever' : 'MFA deixou de ser exigido',
                description: valor ? 'Sessão sem o segundo fator continua lendo o painel, e não escreve.' : undefined,
            });
        } catch (e) {
            setErro(e instanceof Error ? e.message : 'Não foi possível mudar a exigência de MFA.');
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Alert
            tone={semMfa.length > 0 || !ligado ? 'warning' : 'info'} dismissible={false}
            title={semMfa.length === 0
                ? 'Toda a equipe tem MFA'
                : semMfa.length === 1 ? 'Uma pessoa da equipe está sem MFA' : `${String(semMfa.length)} pessoas da equipe estão sem MFA`}
        >
            {semMfa.length > 0 && (
                <p style={{ margin: 0 }}>
                    {semMfa.join(', ')}. Cada um cadastra o próprio autenticador — ninguém cadastra pelo outro.
                    {ligado && ' Com a exigência ligada, essas contas leem o painel e não escrevem até cadastrar e entrar com o segundo fator.'}
                </p>
            )}
            {erro && <p style={{ margin: '8px 0 0', color: 'var(--danger)' }}>{erro}</p>}
            <div style={{ marginTop: 10 }}>
                <Switch
                    checked={Boolean(ligado)}
                    disabled={ligado === null || salvando}
                    onChange={(v) => { void alternar(v); }}
                    label="Exigir MFA para as ações de escrita do painel"
                    description="Ler continua sem o segundo fator. Só liga quem entrou com o MFA nesta sessão."
                />
            </div>
        </Alert>
    );
}
